
import { Compass } from 'lucide-react';
import { ComponentController as BpController, DisplayMode } from '@rta/rta-blueprint-component';

import { Feature, FeatureParams, Require } from '..';
import { useSubscription } from '@rta/rta-blueprint-library';

type showPanelFeatureParams = Require<FeatureParams, 'controller'>;
export const showPanelFeature = (params: showPanelFeatureParams):Feature<boolean> => {
	const { controller, label, panelId, Icon = Compass } = params;

	let displayMode: DisplayMode | null = null;
	const panelActive = controller instanceof BpController && controller?.navigation?.panelId === (panelId ?? null);

	const [disabled] = (() => {
		const isBlueprintController = controller instanceof BpController;
		if (isBlueprintController) {
			({ displayMode } = controller.navigation);
			if (displayMode === DisplayMode.Panel || displayMode === DisplayMode.Manufacturing ||
					displayMode === DisplayMode.Backsplash || displayMode === DisplayMode.BacksplashManufacturing ||
					displayMode === DisplayMode.CornerTrim || displayMode === DisplayMode.CornerTrimManufacturing) {
				return [false];
			}
		}
		return [true];
	})();

	return {
		name: 'show-panel',
		label,
		shortcut: '',
		tooltip: `Show ${label}`,
		icon: (props = {}) => <Icon color={disabled ? 'lightgray' : (panelActive ? 'green' : 'black')} { ...props } />,
		disabled,
		value: false,
		hidden: false,
		// eslint-disable-next-line consistent-return
		handler: () => {
			if (controller instanceof BpController) {
				const { displayMode: currentMode } = controller.navigation;
				if (currentMode === DisplayMode.Backsplash || currentMode === DisplayMode.BacksplashManufacturing ||
						currentMode === DisplayMode.CornerTrim || currentMode === DisplayMode.CornerTrimManufacturing) {
					controller.navigation.displayMode = DisplayMode.Panel;
				}
				if (panelId) {
					controller.navigation.panelId = panelId;
				} else {
					controller.navigation.panelId = null;
				}
			}
		}
	};
};

